import React, { useState, useContext, useEffect, FormEvent } from "react";
import { Grid, Segment, Dropdown, Button, Input } from "semantic-ui-react";
import MobileList from "./MobileList";
import { observer } from "mobx-react-lite";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import MobileStore from "../../../app/stores/mobileStore";
import { Link, RouteComponentProps } from "react-router-dom";

const MobileDashboard: React.FC<RouteComponentProps> = ({
  match,
  location,
  history
}) =>  {
  const mobileStore = useContext(MobileStore);
  const {loadCustomers, loadProjects, searchProject } = mobileStore;
  const [term, setTerm] = useState("");

  const handleInputChange=(event: FormEvent<HTMLInputElement>) => {
    const {value} = event.currentTarget;
    setTerm(value);
    searchProject(event.currentTarget.value);
  }

  useEffect(() => {
    loadCustomers().then(() => {
    const query = new URLSearchParams(location.search);
    (query.get("status")) ?  loadProjects('Mobile', query.get("status")!) : loadProjects('Mobile', "");
    })
  }, []);

  if (mobileStore.loadingInitial)
    return <LoadingComponent content="Loading Projects" />;

  return (
    <Segment>
      <Grid>
        <Grid.Column width={4}>
         <Input  type="text" icon="search" placeholder="Search projects" onChange={handleInputChange} value={term}/>
        </Grid.Column>
        <Grid.Column width={4}>
  
        </Grid.Column>
        <Grid.Column width={5}></Grid.Column>
      <Grid.Column textAlign="center" width={3}>
        <Button
          as={Link}
          to={`/projectmanagement/mobile-create`}
          color="linkedin"
          icon="add"
          content="Create New"
        />
      </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column>
          <MobileList />
        </Grid.Column>
        
      </Grid>
    </Segment>
  );
};

export default observer(MobileDashboard);
